import { get } from "../../util/requestUtils"

export function findCategoryList(id, fetchAll, success) {
  return new Promise((resolve)=> {
    const s = get("/ask/public-api/category/list", { id: id, fetchAll: fetchAll }, success)
    resolve(s)
  })
}
